<template>
  <div class="meeting-engineer__wrapper">
    <p class="meeting-engineer__title">Meeting the engineer</p>
    <div class="meeting-engineer__container">
      <p class="meeting-engineer__text">{{ parkingDetails.question }}</p>
      <InputField
        v-model="parkingDetailsAnswer"
        data-testid="parking-details"
        label="e.g. driveway, street parking (is a permit required etc.?)"
        name="appointmentPreferences"
        force-label-up
        multiline
        autofocus
        full-width
      />
      <p class="meeting-engineer__text">
        {{ petDetails.question }}
      </p>
      <RadioGroup
        v-model="petDetailsBoolean"
        :options="petDetailsOptions"
        data-testid="pet-details"
      />

      <InputField
        v-if="petDetailsBoolean"
        v-model="petDetailsTextAnswer"
        data-testid="pet-details-text"
        label="Please add details of your pets here. e.g. ‘Two excitable small dogs who can be kept in the garden.’"
        force-label-up
        multiline
        autofocus
        full-width
      />
      <AppButton
        class="meeting-engineer__next-button"
        :disabled="!validated"
        data-testid="meeting-engineer-continue-button"
        @click="nextStep"
      >
        <span> Continue </span>
        <span class="meeting-engineer__icon icon icon-arrow-right" />
      </AppButton>
    </div>
  </div>
</template>

<script>
import AppButton from "@soenergy/frontend-library/src/components/AppButton.vue"
import InputField from "@soenergy/frontend-library/src/components/InputField.vue"
import { RadioGroup } from "@soenergy/frontend-library/src/components/RadioButton"

export default {
  components: {
    RadioGroup,
    AppButton,
    InputField,
  },
  emits: ["go-forward"],
  data() {
    return {
      petDetailsOptions: [
        {
          label: "Yes I have pets",
          value: true,
          inputId: "meeting-engineer-pet",
        },
        {
          label: "No I don’t have pets",
          value: false,
          inputId: "meeting-engineer-no-pet",
        },
      ],
    }
  },
  computed: {
    parkingDetails() {
      return this.$store.state.questionnaire["parkingDetails"]
    },
    petDetails() {
      return this.$store.state.questionnaire["petDetails"]
    },
    parkingDetailsAnswer: {
      get() {
        return this.parkingDetails.answer
      },
      set(value) {
        this.$store.commit("SET_PARKING_DETAILS_ANSWER", value)
      },
    },
    petDetailsAnswer() {
      return this.petDetails.answer
    },
    petDetailsTextAnswer: {
      get() {
        return this.petDetailsAnswer !== this.petDetailsOptions[0].label &&
          this.petDetailsAnswer !== this.petDetailsOptions[1].label
          ? this.petDetailsAnswer
          : ""
      },
      set(value) {
        this.$store.commit("SET_PET_DETAILS_ANSWER", value)
      },
    },
    petDetailsBoolean: {
      get() {
        if (this.petDetails.answer === null) return null
        return this.petDetails.answer !== this.petDetailsOptions[1].label
      },
      set(value) {
        const answer = value
          ? this.petDetailsOptions[0].label
          : this.petDetailsOptions[1].label
        this.$store.commit("SET_PET_DETAILS_ANSWER", answer)
      },
    },
    validated() {
      return (
        ((this.petDetailsBoolean && this.petDetailsTextAnswer) ||
          (!this.petDetailsBoolean && this.petDetailsAnswer)) &&
        this.parkingDetailsAnswer
      )
    },
  },
  methods: {
    nextStep() {
      this.$emit("go-forward")
    },
  },
}
</script>

<style lang="scss" scoped>
.meeting-engineer {
  font-size: $font-size-4;
  &__wrapper {
    margin-bottom: $space-12;
    ::v-deep .form-group__input-group {
      max-width: 100%;
    }
  }
  &__icon {
    margin-left: $space-1;
  }
  &__title {
    font-size: $font-size-5;
    font-weight: $weight-medium;
    margin-bottom: $space-3;

    @include md {
      font-size: $font-size-6;
    }
  }

  &__text {
    margin-top: $space-3;
    font-size: $font-size-3;

    @include md {
      font-size: $font-size-4;
    }
  }
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__checkbox {
    margin-top: $space-2;
    margin-bottom: $space-3;
  }

  &__next-button {
    width: 100%;
    margin-top: $space-4;

    @include md {
      margin-bottom: $space-4;
    }
  }
}

::v-deep .checkbox__input:checked + .checkbox__label {
  font-weight: $weight-normal;
}
::v-deep .accordion__heading h4 {
  font-size: $font-size-5;
  font-weight: $weight-medium;
}
</style>
